// extracted by mini-css-extract-plugin
module.exports = {"container":"stageInvest-style--container--XAmey","inputContainer":"stageInvest-style--inputContainer--1Dps6","explain":"stageInvest-style--explain--3qvQH"};